import { useContext } from 'react';
import { ConfigContext } from './provider';

export function useConfigContext() {
  return useContext(ConfigContext);
}

export default useConfigContext;
